import {
  Button,
  Emphasis,
} from "@lya-protect/lya-protect-form-library/dist/UI";
import { LinkButton } from "@src/components/linkButton/LinkButton";
import { RecapCard } from "@src/components/recapCard/RecapCard";
import { StepProps } from "@src/Steps/step/Steps";
import { ReactComponent as CheckCircle } from "@src/svg/check-circle.svg";
import "./subscriptionIntroduction.scss";

export type SubscriptionIntroductionData = undefined;
type SubscriptionIntroductionProps = StepProps<SubscriptionIntroductionData>;

export function SubscriptionIntroduction({
  changeStep,
  projetPreSouscription,
}: SubscriptionIntroductionProps) {
  if (!projetPreSouscription) return changeStep("LANDING", "backward");

  return (
    <div className="subscription-introduction-step">
      <div className="stepper__centered-container">
        <div className="stepper__centered-content step__grid step__grid--padding-bottom">
          <div className="subscription-introduction-step__main">
            <CheckCircle className="subscription-introduction-step__svg" />
            <h1>
              Vous vous apprêtez à poursuivre le parcours de souscription au
              contrat&nbsp;
              <Emphasis>
                Paxivie qui vous couvre et vous accompagne en cas
                d&apos;accidents de la vie courante* ainsi qu&apos;en cas de
                décès accidentel
              </Emphasis>
            </h1>
            <p>Voici le récapitulatif des garanties choisies :</p>
          </div>
          <div className="step__grid-bloc subscription-introduction-step__recap">
            <RecapCard
              fullname={`${projetPreSouscription?.contact.name} ${projetPreSouscription?.contact.surname}`}
              couvertureName={projetPreSouscription?.tarif.name}
              simulationCotisationMonth={
                projetPreSouscription?.tarif.simulationCotisation
              }
            />
            <div className="subscription-introduction-step__edit-container">
              <LinkButton onClick={() => changeStep("TARIF", "backward")}>
                Modifier ma formule
              </LinkButton>
              <LinkButton
                onClick={() => changeStep("CONTACT_INFOS", "backward")}
              >
                Modifier mes informations personnelles
              </LinkButton>
            </div>
            <small>
              * Prise en charge dès 1 % d&apos;AIPP (Atteinte à l&apos;Intégrité
              Physique et Psychique consolidée)
            </small>
          </div>
          <Button onClick={() => changeStep("VALIDATE_POINTS", "forward")}>
            Continuer
          </Button>
        </div>
      </div>
    </div>
  );
}
